import React from 'react'
import Layout from '../components/Layout/Layout'
import { EmotionSurvey } from '../components/EmotionSurvey'

// Standalone, shareable survey page (no site header/footer) - hence the
// minimal template. Prototype: responses live in memory, not yet wired to a
// backend. Slug is a placeholder, easy to rename.
export function Head() {
  return (
    <>
      <title>How does AI really make you feel?</title>
      <meta
        name="description"
        content="An anonymous, 30-second gut check: pick the feeling AI gives you, say why, and see how everyone else really feels."
      />
    </>
  )
}

const HowAiFeelsPage = ({ location }) => (
  <Layout location={location} templateKey="minimal" inverse={false}>
    <EmotionSurvey />
  </Layout>
)

export default HowAiFeelsPage
